/**
 * @deprecated Import from 'src/integrations/vanilla-js/index.js' instead.
 */
export {
  run as runVanillaJsInstallerAgent,
  config as VANILLA_JS_AGENT_CONFIG,
} from '../integrations/vanilla-js/index.js';
